import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import PromoteFlowStep from './PromoteFlowStep'

class DatesStep extends PromoteFlowStep {
  constructor(component: ReactNode) {
    super(i18n.t('contract_versions.flows.promote.steps.dates.title'), component)
  }
}

export default DatesStep
